import { RouteNames } from '@ui/routes';
export function handleForbiddenRedirect(errorMessage, errorCode) {
    sessionStorage.setItem('axiosErrorMessage', errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'Access Denied');
    sessionStorage.setItem('axiosError', errorCode !== null && errorCode !== void 0 ? errorCode : '');
    const targetUrl = new URL(RouteNames.FORBIDDEN, window.location.origin);
    targetUrl.searchParams.set('from', window.location.pathname);
    window.location.href = targetUrl.toString();
}
